import React, { useEffect, useState, useContext } from 'react'
import ListingTableView from '@/views/TableView/TableView'
import { Button } from '@mui/material'
import Layout from '../../product/components/templates/Layout'
import DynamicListing from './dynamicListing'
import ReportContext from '@/product/context/report/reportContext'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import DynamicBulkListing from '@/product/components/organisms/BulkUpload/ProjectUpload'
import MakeOffer from './MakeOffer'
import Comments from '../Comments/Comments'
import { handleRedirectInternal } from '../../custom/common/components'
import { useHistory } from 'react-router-dom'
import PrivateAuction from './PrivateAuction'

const ListingCommon = (props) => {
    const dynamicContext = useContext(DynamicContext)

    const { project_tablefields } = dynamicContext

    const { getAllExportDownload } = useContext(ReportContext)

    const [searchInfo, setSearchInfo] = useState({})
    const [tableValue, setTableValue] = useState([])
    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
        id: 0,
        projectType: 0,
    })
    const [bulkPopup, setBulkPopup] = useState(false)
    const toggleBulkPopup = (popup) => {
        setBulkPopup({ popup })
    }
    const history = useHistory()
    const onClickEdit = (id, secondaryID, type) => {
        if (type === 'edit') {
            handleRedirectInternal(history, `listing/edit/${id}`)
        }
    }
    const onClickInvoiceEdit = (id, secondaryID, type) => {
        handleRedirectInternal(
            history,
            `invoice/view/paid/${id}/${secondaryID}`
        )
    }

    const toggleFullScreenPopup = (popup, status, id, projectType) => {
        if (popup && (status == 'new' || status == 'edit')) {
            handleRedirectInternal(history, `listing/${status}/${id}`)
        } else if (popup) {
            setManage({ popup, status, id, projectType })
        } else {
            setManage({ popup, status: 'new', id: 0 })
        }
    }

    let action = props.match.params.action

    const custom = {
        action: {
            value: action
                ? action.toString() !== 'all'
                    ? action.toString()
                    : ''
                : null,
            type: 'in',
            field: 'p.market_status',
        },
    }

    useEffect(() => {
        if (project_tablefields && project_tablefields.length) {
            let dynamicValueAssign = {}
            let searchData = project_tablefields
            dynamicValueAssign.data = searchData
                .filter((item) => item.table_search === 1)
                .map((buscat) => {
                    return Object.assign(buscat, {
                        name: buscat.field,
                    })
                })
            setSearchInfo(dynamicValueAssign)
            let dynamicAssign = [...project_tablefields]
            dynamicAssign.map((data) => {
                if (data.field === 'auctiontitle' || data.field == 'title') {
                    data.click = true
                    data.class = 'col-sm-4 col-12'
                    data.onclick = onClickEdit
                    data.clickID = 'id'
                    data.secondaryClickID = 'user_id'
                    data.clickType = 'edit'
                    data.type = 'hyperlink'
                } else if (data.field == 'buynow_common_invoice') {
                    data.click = true
                    data.onclick = onClickInvoiceEdit
                    data.clickID = 'buynow_common_invoice'
                    data.secondaryClickID = 'buynow_user_id'
                    data.clickType = 'edit'
                    data.type = 'hyperlink'
                    data.name = 'buynow_common_invoice'
                    data.sort_field = ''
                }
                // if (data.type == 'price') {
                //     data.type = 'countryprice'
                //     data.countryfield = 'charity_country'
                // }
                // if (data.field == 'amount') {
                //     data.field = 'buynow_amount'
                //     data.type = 'countryprice'
                //     data.countryfield = 'charity_country'
                // }

                if (data.field === 'buynow_paid_date') {
                    data.field = 'buynow_date_added'
                }
            })
            if (action === 'draft') {
                dynamicAssign.push({
                    active: 1,
                    field: 'requiredFieldsStatus',
                    folder: null,
                    id: 21,
                    is_deletable: 0,
                    label: 'Status',
                    show_order: 500,
                    sort: 0,
                    sort_field: 'p.wprice',
                    table_search: 0,
                    type: 'tooltip',
                    tooltipTitle: 'requiredFields',
                    tooltipType: 'field',
                    view_page: '1',
                })
            }

            setTableValue(dynamicAssign)
        }
    }, [project_tablefields, action])

    return (
        <>
            <Layout>
                <div className="dashboard listing maillisting">
                    <div className="miscActions d-flex justify-content-start align-items-center flex-wrap mt-4">
                        <Button
                            id="listingDynamic_add"
                            variant="outlined"
                            className="btnOutlined mr-2"
                            onClick={() =>
                                toggleFullScreenPopup(true, 'new', 0, 5)
                            }
                        >
                            <span className="material-icons">note_add</span>Add
                            New Offer
                        </Button>
                        {/* <Button
                            id="listingDynamic_add2"
                            variant="outlined"
                            className="btnOutlined mr-2"
                            onClick={() =>
                                toggleFullScreenPopup(true, 'new', 0, 6)
                            }
                        >
                            <span className="material-icons">note_add</span>Add
                            New Whole Sale Listing
                        </Button> */}
                        {/* <Button
                            id="listingDynamic_bulk"
                            variant="outlined"
                            className="btnOutlined"
                            onClick={() => toggleBulkPopup(true)}
                        >
                            <span className="material-icons">note_add</span>Add
                            New Bulk Listing
                        </Button> */}
                        <Button
                            id="listingDynamic_report"
                            variant="outlined"
                            className="btnOutlined"
                            onClick={() =>
                                getAllExportDownload({
                                    action: 'export',
                                    order: 'asc',
                                    orderby: '',
                                    search: 'all',
                                    report: `${action}_product_management`,
                                    replaceName: {
                                        title: 'Offer Title',
                                    },
                                    fields: ['title'],
                                })
                            }
                        >
                            <span className="material-icons-outlined">
                                file_download
                            </span>
                            Export All Data
                        </Button>
                    </div>

                    <ListingTableView
                        searchInfo={searchInfo}
                        customFilter={custom}
                        tableValue={tableValue}
                        toggleFullScreenPopup={toggleFullScreenPopup}
                        tableActionString={[
                            'open',
                            'auction_assign',
                            'date_closed',
                            'removed',
                            'unsold',
                        ]}
                        listActionString={[
                            'bidcount',
                            'makeoffer',
                            'questions',
                            'private',
                        ]}
                        action={action}
                        tooltipTitle={'Interested Users'}
                    />
                </div>

                <MakeOffer data={manage} function={toggleFullScreenPopup} />
                <Comments data={manage} function={toggleFullScreenPopup} />
                <PrivateAuction
                    data={manage}
                    function={toggleFullScreenPopup}
                />
                <DynamicBulkListing
                    data={bulkPopup}
                    function={toggleBulkPopup}
                    ignoreFields={[
                        'uploadimages',
                        'wprice',
                        'date_added',
                        'date_closed',
                        'buynow',
                        'bprice',
                        'location_id',
                    ]}
                />
            </Layout>
        </>
    )
}

export default ListingCommon
